import { ref } from 'vue'

export const useModel = () => {
  const direction = ref('bottom')

  /**
   * Функция начала перемещения объекта
   * @param event
   * @param closets
   * @param index
   */
  const dragStartHandler = (event: DragEvent, closets: string, index: number | string) => {
    const transferElement = event.currentTarget as HTMLElement
    const parent = transferElement.closest(closets)

    if (!parent || !event.dataTransfer) return

    const dragImage = parent.cloneNode(true) as HTMLElement
    dragImage.classList.add('drag-item__draggable')

    document.body.appendChild(dragImage)
    event.dataTransfer.setDragImage(dragImage, 15, 24)

    setTimeout(() => {
      if (document.body.contains(dragImage)) document.body.removeChild(dragImage)
    }, 0)

    const transfer = event.dataTransfer
    transfer.setData('drag-index', String(index))
  }

  /**
   * Функция перемещения по целевому элементу
   * @param event
   */
  const dragOverHandler = (event: DragEvent) => {
    const target = event.currentTarget as HTMLElement

    const coords = target.getBoundingClientRect()
    const mousePosition = event.clientY

    target.classList.add('drag-item__target')

    if (coords.top + coords.height / 2 > mousePosition) {
      target.classList.remove('drag-item__target_bottom')
      target.classList.add('drag-item__target_top')
      direction.value = 'top'
    } else {
      target.classList.remove('drag-item__target_top')
      target.classList.add('drag-item__target_bottom')
      direction.value = 'bottom'
    }
  }

  /**
   * Функция ухода с целевого элемента
   * @param event
   */
  const dragLeaveHandler = (event: DragEvent) => {
    const target = event.currentTarget as HTMLElement

    target.classList.remove(
      'drag-item__target',
      'drag-item__target_top',
      'drag-item__target_bottom',
    )
  }

  /**
   * Функция отпускания на целевом элементе
   * @param event
   * @param targetIdx
   * @param handler
   */
  const dropHandler = (event: DragEvent, targetIdx: number | string, handler: Function) => {
    const target = event.currentTarget as HTMLElement

    if (!target || !event.dataTransfer) return

    target.classList.remove(
      'drag-item__target',
      'drag-item__target_top',
      'drag-item__target_bottom',
    )

    const transfer = event.dataTransfer
    const index = transfer.getData('drag-index')

    handler(targetIdx, index, direction.value)
  }

  return {
    dragStartHandler,
    dragOverHandler,
    dragLeaveHandler,
    dropHandler,
  }
}
